import React from "react";
import { connect } from "react-redux";
import { Route } from "react-router-dom";
import Header from "../components/layouts/Header";
import SideBar from "../components/layouts/Sidebar";
import { configCheck } from "./commonAction";
import Authorization from "../utility/authorization";
class Application extends React.Component {
  componentDidMount() {
    this.props.isLoggedIn() && this.props.dispatch(configCheck());
  }
  componentWillReceiveProps(props) {
    if (
      this.props.isLoggedIn() &&
      this.props.configCheck.response !== props.configCheck.response
    ) {
      if (props.configCheck.status == 200) {
        let AuthValues = {
          ...Authorization.getAuthUser(),
          ...props.configCheck.response
        };
        Authorization.login(AuthValues);
        // if (
        //   (!AuthValues.newbookingReqForAdmins &&
        //     window.location.pathname === "/booking/add") ||
        //   (!AuthValues.isApiEnabled &&
        //     window.location.pathname === "/api-document") ||
        //   (!AuthValues.showTripsheet &&
        //     window.location.pathname === "/tripsheet") ||
        //   (!AuthValues.showTripList &&
        //     window.location.pathname === "/triplist/pending") ||
        //   (!AuthValues.showTripList &&
        //     window.location.pathname === "/triplist/inprogress") ||
        //   (!AuthValues.showTripList &&
        //     window.location.pathname === "/triplist/pending" &&
        //     window.location.pathname === "/triplist/inprogress" &&
        //     window.location.pathname === "/triplist/completed") ||
        //   (!AuthValues.showReports &&
        //     window.location.pathname === "/reports/active") ||
        //   (!AuthValues.showReports &&
        //     window.location.pathname === "/reports/completed") ||
        //   (!AuthValues.accessMatrix &&
        //     window.location.pathname === "/users/employee") ||
        //   (!AuthValues.accessMatrix &&
        //     window.location.pathname === "/users/admin")
        // ) {
        //   props.history.push("*");
        // }
      }
    }
  }
  render() {
    const {
      component: Component,
      isLoggedIn,
      auth,
      authorizedPages,
      sidebar: { visible: isOpen },
      ...rest
    } = this.props;

    return (
      <Route
        {...rest}
        render={props => {
          return (
            <div className="main-body">
              {isLoggedIn() ? (
                <React.Fragment>
                  <Header isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  <SideBar isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  <div className={isOpen ? "content" : "content open"}>
                    <Component isLoggedIn={isLoggedIn} auth={auth} {...props} />
                  </div>
                </React.Fragment>
              ) : (
                <Component isLoggedIn={isLoggedIn} auth={auth} {...props} />
              )}
            </div>
          );
        }}
      />
    );
  }
}

export default connect(state => {
  return {
    sidebar: state.sidebar,
    configCheck: state.configCheck
  };
})(Application);
